import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SimpleSelectProps, SimpleSelect } from '@agro-club/frontend-shared'
import { LifeCycleTerritory } from 'types/entities'

const LifeCycleTerritorySelect: React.FC<Omit<SimpleSelectProps, 'options'>> = ({ ...selectProps }) => {
  const { t } = useTranslation('contactLifeCycle')
  const options = useMemo(() => {
    return Object.keys(LifeCycleTerritory).map((e) => {
      return { id: LifeCycleTerritory[e], title: LifeCycleTerritory[e] }
    })
  }, [t])

  return <SimpleSelect {...selectProps} options={options} isClearable />
}

export default LifeCycleTerritorySelect
